/**
 * PersonasMasterView -- #/personas: todas las personas activas de todos los negocios.
 * Mision SUJETO-PERSONA-V1-001 / SUJ-T3 (ASSIGN #17005).
 *
 * AUDIENCIA: el admin de plataforma (Josse), escritorio. Audiencia 'nexo' en main.js y NavBar:
 * el dueno de un negocio no la ve. El API la sirve solo a admin de plataforma (spec-persona-v1).
 *
 * Una fila por persona: sus negocios con el cargo, si entra al panel, sus fichas de operacion
 * con PIN si/no (nunca el PIN) y sus Nexos. Reglas en application/personas/listaMaster.js.
 *
 * @module presentation/views/PersonasMasterView
 */

import { PersonaApiClient } from '../../infrastructure/api/PersonaApiClient.js';
import { leerListaMaster, porQueNoHayLista, filtrarPersonas, celdasDeLaFila, busquedaDeLaRuta } from '../../application/personas/listaMaster.js';
import { rutaDeLaFicha } from '../../application/personas/fichaUnica.js';

// Deuda 4: era una copia del escape; ahora es el compartido.
import { esc } from '../shared/texto.js';
import { regresoHtml } from '../shared/regreso.js';

function tabla(personas) {
  if (!personas.length) return '<p class="empty-state">Ninguna persona coincide.</p>';
  const cab = ['Persona', 'Negocios', 'Entra al panel', 'Operación', 'Nexos']
    .map((t) => `<th style="text-align:left;padding:8px 10px;color:var(--text-secondary);font-weight:600;font-size:0.875rem;border-bottom:1px solid var(--border-default)">${t}</th>`).join('');
  // SUJ-T8: la fila abre la ficha unica.
  const filas = personas.map((p) => `<tr data-persona="${esc(p.personaId)}" data-ruta="${esc(rutaDeLaFicha('persona', p.personaId))}" style="cursor:pointer" title="Abrir la ficha">${celdasDeLaFila(p)
    .map((c, i) => `<td style="padding:8px 10px;border-bottom:1px solid var(--bg-tertiary);font-size:0.875rem;color:${i === 0 ? 'var(--text-strong)' : 'var(--text-heading)'}">${esc(c)}</td>`).join('')}</tr>`).join('');
  return `<div style="overflow-x:auto"><table style="width:100%;border-collapse:collapse"><thead><tr>${cab}</tr></thead><tbody>${filas}</tbody></table></div>`;
}

export async function renderPersonasMaster(container) {
  container.innerHTML = `
    <section class="artifact-view">
      <div class="artifact-header">
        <div>
          ${regresoHtml()}
          <h1>Personas</h1>
          <p class="subtitle">Todas las personas activas de todos los negocios: una persona, sus llaves y sus negocios</p>
        </div>
      </div>
      <div class="task-filter-bar" data-personas-pestanas style="margin-bottom:10px">
        <button class="btn-filter active" data-personas-pestana="negocios">De los negocios</button>
        <button class="btn-filter" data-personas-pestana="agente">Del agente</button>
      </div>
      <div data-personas-negocios>
        <input id="nx-personas-buscar" class="form-input" placeholder="Buscar por nombre o negocio" style="max-width:320px;margin-bottom:12px" hidden>
        <div id="nx-personas-lista"><p class="empty-state">Cargando personas…</p></div>
      </div>
      <div data-personas-agente-host hidden></div>
    </section>`;

  // PANEL-WA-USERS-T1: la pestana "Del agente" (quien habla con Argemiro) se carga al abrirla, no antes.
  const $negocios = container.querySelector('[data-personas-negocios]');
  const $agente = container.querySelector('[data-personas-agente-host]');
  container.querySelector('[data-personas-pestanas]').addEventListener('click', async (e) => {
    const b = e.target.closest('[data-personas-pestana]');
    if (!b) return;
    container.querySelectorAll('[data-personas-pestana]').forEach((x) => x.classList.toggle('active', x === b));
    const agente = b.dataset.personasPestana === 'agente';
    $negocios.hidden = agente;
    $agente.hidden = !agente;
    if (agente && !$agente.dataset.cargado) {
      $agente.dataset.cargado = '1';
      const { renderPersonasDelAgente } = await import('./personas/delAgente.js');
      await renderPersonasDelAgente($agente);
    }
  });

  const $lista = container.querySelector('#nx-personas-lista');
  const $buscar = container.querySelector('#nx-personas-buscar');
  const res = await PersonaApiClient.listar({ estado: 'active', page: 1, pageSize: 200 });
  const falta = porQueNoHayLista(res);
  if (falta) {
    $lista.innerHTML = `<p class="empty-state" data-personas-motivo="${esc(falta.motivo)}">${esc(falta.frase)}</p>`;
    return;
  }
  const { personas, total } = leerListaMaster(res);
  const pintar = () => {
    const vistas = filtrarPersonas(personas, $buscar.value);
    $lista.innerHTML = `<div style="font-size:0.875rem;color:var(--text-secondary);margin-bottom:8px">${vistas.length} de ${total} persona${total === 1 ? '' : 's'} · el PIN nunca se muestra, solo si lo tiene</div>${tabla(vistas)}`;
  };
  $buscar.hidden = false;
  // PANEL-SUJETOS-LISTA-T1: desde la ficha del negocio llega #/personas?q=<negocio> y la lista abre filtrada.
  $buscar.value = busquedaDeLaRuta(window.location.hash);
  $buscar.addEventListener('input', pintar);
  $lista.addEventListener('click', (e) => {
    const ruta = e.target.closest('tr[data-ruta]')?.dataset.ruta;
    if (ruta) window.location.hash = ruta;
  });
  pintar();
}
